import React, { useState } from 'react';
import { ListDashItens } from '../../../../../../components/NovoSistema/ListDashItens';
import SubTitle from '../../../../../../components/NovoSistema/SubTitle';
import ModalImageDash from '../../../../../../components/NovoSistema/ModalImageDash';

export default function AnaliseCusto() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/controladoria/dashboard/BAF/';
  const nameImage = 'analise-custo';
  return (
    <main>
      <SubTitle text="ANÁLISE – Custo na Prestação do Serviço | Custo de Mercadoria Vendida " />
      <ListDashItens>
        <li>Corte: AGO21.</li>
        <li>Variação média superavitária de 11,03 do custo realizado.</li>
        <li>
          CSP com tendência de crescimento superior ao CMV em 7,5%, entretanto na média o crescimento do custo médio até
          o fechamento do FY tende a 5,2%.
        </li>
      </ListDashItens>
      <img
        onClick={() => setOpenModal(true)}
        src={`${prefix}${nameImage}.png`}
        alt={nameImage}
        style={{ width: '100%' }}
      />
      {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
    </main>
  );
}
